import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdminE911ContainerComponent } from "@onsip/web/features/administrators/e911/container/e911-container.component";
import { E911Guard } from "@onsip/web/features/shared/guards/e911Guard.guard";
import { E911Resolver } from "@onsip/web/features/shared/resolvers/e911-resolver.resolver";
import { AdminE911TableComponent } from "@onsip/web/features/administrators/e911/e911Table/e911-table.component";
import { AdminE911NoBalanceComponent } from "@onsip/web/features/administrators/e911/emptyStates/noBalance/e911-no-balance.component";
import { AdminE911NoLocationComponent } from "@onsip/web/features/administrators/e911/emptyStates/noLocation/e911-no-location.component";
import { AdminE911NoFreeTrialComponent } from "@onsip/web/features/administrators/e911/emptyStates/noFreeTrial/e911-no-free-trial.component";
import { AdminE911InvoicedPrepaidComponent } from "@onsip/web/features/administrators/e911/emptyStates/invoicedPrepaid/e911-invoiced-prepaid.component";

const routes: Routes = [
  {
    path: "",
    component: AdminE911ContainerComponent,
    children: [
      {
        path: "",
        pathMatch: "full",
        canActivate: [E911Guard],
        resolve: { e911: E911Resolver },
        component: AdminE911TableComponent,
        runGuardsAndResolvers: "always"
      },
      {
        path: "no-balance",
        canActivate: [E911Guard],
        component: AdminE911NoBalanceComponent,
        runGuardsAndResolvers: "always",
        data: { title: "No Balance" }
      },
      {
        path: "no-location",
        canActivate: [E911Guard],
        component: AdminE911NoLocationComponent,
        runGuardsAndResolvers: "always",
        data: { title: "No Location" }
      },
      {
        path: "no-free-trial",
        canActivate: [E911Guard],
        component: AdminE911NoFreeTrialComponent,
        runGuardsAndResolvers: "always",
        data: { title: "No Free Trial" }
      },
      {
        path: "invoiced-prepaid",
        canActivate: [E911Guard],
        component: AdminE911InvoicedPrepaidComponent,
        runGuardsAndResolvers: "always",
        data: { title: "Invoiced Prepaid" }
      }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)]
})
export class AdminE911RoutingModule {}
